import {Component, OnInit} from '@angular/core';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {CommonService} from '@services/common.service';
import {FormService} from '@services/form.service';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {AuthenticationService} from '@services/authentification.service';
import {UserService} from '@services/user.service';
import {environment} from '~/environments/environment';
import {HttpClient} from '@angular/common/http';
import {TrackingService} from '@services/tracking.service';
import {ActivatedRoute} from '@angular/router';
import {Invoice} from '@models/invoice';
import {AlertService} from '@services/alert.service';
import {MatDialog} from '@angular/material/dialog';
import {DeleteUserComponent} from '@module/users/popup/delete-user/delete-user.component';

declare global {
    interface Window {
        WonderPush: any;
    }
}

@Component({
    selector: 'app-account',
    templateUrl: './account.component.html',
    styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit {
    accountForm: UntypedFormGroup;
    passwordForm: UntypedFormGroup;
    user: User = Object.assign({}, EMPTY_USER);
    stripe = Stripe(environment.stripeKey);
    hide = true;
    invoices = [];
    filleuls = [];
    editPaiement = '';
    totalComm = 0;

    constructor(
        private formBuilder: UntypedFormBuilder,
        public commonService: CommonService,
        public formService: FormService,
        public userService: UserService,
        public alertService: AlertService,
        private route: ActivatedRoute,
        public authenticationService: AuthenticationService,
        public trackingService: TrackingService,
        public dialog: MatDialog,
        private http: HttpClient) {
    }

    ngOnInit(): void {
        this.editPaiement = this.route.snapshot.queryParams.editPaiement || 'false';
        if (this.editPaiement === 'true') {
            this.updateCB();
        }

        this.accountForm = this.formBuilder.group({
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            plan: [''],
            email: [{value: '', disabled: true}, [Validators.required, Validators.email]],
            mailing: [''],
            adress: [''],
            city: [''],
            zip_code: [''],
            company_name: [''],
            mobile: [],
        });

        this.passwordForm = this.formBuilder.group({
            old_password: ['', [Validators.minLength(8)]],
            new_password: ['', [Validators.required, Validators.minLength(8)]],
            new_password2: ['', [Validators.required, Validators.minLength(8)]]
        }, {validator: this.matchingPasswords('new_password', 'new_password2')});

        this.user = this.authenticationService.currentUser;

        let data = {
            mobile: "",
        }
        if (this.user.pro_data !== "") {
            data = JSON.parse(this.user.pro_data);
        }
        this.accountForm = this.formBuilder.group({
            firstName: [this.user.firstname, Validators.required],
            lastName: [this.user.lastname, Validators.required],
            plan: [this.user.plan],
            email: [{value: this.user.email, disabled: true}, [Validators.required, Validators.email]],
            mailing: [this.user.mailing],
            adress: [this.user.adress],
            city: [this.user.city],
            zip_code: [this.user.zip_code],
            company_name: [this.user.company_name],
            mobile: [data.mobile === undefined ? '' : data.mobile],
        });

        this.userService.getInvoice().subscribe(invoices => {
            this.invoices = invoices;
        }, error => {
        });

        this.userService.getFilleul().subscribe(filleuls => {
            this.filleuls = filleuls;
            if (this.authenticationService.isInfluenceur(this.user)) {
                let tauxComm = this. authenticationService.getInfluenceurRevenue(this.user).commission
                this.filleuls.forEach((filleul) => {
                    this.totalComm += (filleul.total / 100 / 100 / 1.2) * tauxComm;
                });
            }
        }, error => {
        });

        if (window.WonderPush !== undefined) {
            window.WonderPush.push(function() {
                window.WonderPush.showSubscriptionSwitch(
                    document.getElementById('wonderpush-subscription-switch'),
                    {
                        sentence: "Activer les notifications sur cet appareil : ",
                        colorOn: "#0075DB",
                    }
                );
            });
        }

        this.onChanges();
    }

    matchingPasswords(passwordKey: string, confirmPasswordKey: string) {
        return (group: UntypedFormGroup): { [key: string]: any } => {
            const password = group.controls[passwordKey];
            const confirmPassword = group.controls[confirmPasswordKey];

            if (password.value !== confirmPassword.value) {
                return {
                    mismatchedPasswords: true
                };
            }
        };
    }

    onChanges(): void {
        this.accountForm.valueChanges.subscribe(val => {
            if (this.accountForm.invalid) {
                return;
            }

            const form = this.accountForm.getRawValue();
            Object.keys(form).forEach((k) => {
                this.user[k] = form[k];
            });
            this.user.pro_data = JSON.stringify({mobile: form['mobile']});
            this.userService.updateAccount(this.user);
        });
    }

    updateCB() {
        this.http.post<any>(`${environment.apiUrl}app/paiement/create-update-checkout-session`, {}).subscribe(
            session => {

                this.stripe.redirectToCheckout({sessionId: session.id}).then(result => {
                    if (result.error) {
                        alert(result.error.message);
                    }
                });
            },
            (error) => {
                console.log(error);
            });
    }

    passwordUpdate(): void {
        if (this.passwordForm.invalid) {
            return;
        }
        this.userService.updatePassword(this.passwordForm.getRawValue());
    }

    openInvoice(invoice: Invoice): void {
        this.userService.getInvoiceLink(invoice).subscribe(
            result => {
                if (!result.url) {
                    this.alertService.error('Une erreur est survenue, veillez nous contacter.');
                } else {
                    window.open(result.url, "_blank");
                }
            },
            (error) => {
                console.log(error);
            });
    }

    deleteAccount() {
        const dialogRef = this.dialog.open(DeleteUserComponent, {
            width: '440px',
            height: '400px',
        });
    }
}
